import { Component, OnInit, OnDestroy } from "@angular/core";
import { NavigationService } from "../../../providers/navigation.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../../../providers/api.service";
import { Subscription } from "rxjs";
import { SM_CONSTANTS } from "../../../shared/constants/sm-constants";
import { ITableColumnHeader } from "../../../models/table-column-header";
import { AddServiceComponent } from "src/app/shared/components/add-service/add-service.component";
import { MatDialog } from "@angular/material/dialog";
import { SharedService } from "../../../providers/shared.service";
import { UntypedFormControl } from "@angular/forms";
import { AddServiceTemplateItemComponent } from "src/app/shared/components/add-service-template-item/add-service-template-item.component";
import { MessagingService } from "src/app/providers/messaging.service";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { TranslateService } from "@ngx-translate/core";
import { PaymentIntimationComponent } from "src/app/shared/components/payment-intimation/payment-intimation.component";
import { YoutubeEmbedVideoComponent } from "../../new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { AddMemberComponent } from "src/app/shared/components/add-member/add-member.component";
import { MemberViewDetailsComponent } from "src/app/shared/components/member-view-details/member-view-details.component";
import { AddCustomerComponent } from "src/app/shared/components/add-customer/add-customer.component";
import { CreateInvoiceForCustomersComponent } from "src/app/shared/components/create-invoice-for-customers/create-invoice-for-customers.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { CustomersViewDetailsComponent } from "../../new-v2-pages/new-v2-component/customers-view-details/customers-view-details.component";
import { formatDate } from "@angular/common";
import { DialogService } from "src/app/providers/dialog.service";
import { Share } from "@capacitor/share";
import { AuthService } from "src/app/providers/auth.service";
@Component({
  selector: "sm-customers",
  templateUrl: "./customers.component.html",
  styleUrls: ["./customers.component.scss"],
})
export class CustomersComponent implements OnInit, OnDestroy {
  isAccessForEmployeeInvoice: boolean = false;

  isOwner: boolean = false;
  discountInfo: any = null;
  entityHashId: string = "";
  isEntityIndividual: any;
  // clickEventSubscription: Subscription
  public loader: boolean = false;
  customersData: any[] = [];
  private _apiSubscription: Subscription;
  datalength!: number;
  public page: number = 1;
  searchString: UntypedFormControl = new UntypedFormControl("");
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant(
        "customers.column_headers.name",
      ),
      columnProperty: "name",
    },
    {
      columnName: this.translateService.instant(
        "customers.column_headers.phone",
      ),
      columnProperty: "cust_phone",
    },
    {
      columnName: this.translateService.instant(
        "customers.column_headers.gender",
      ),
      columnProperty: "gender1",
    },
    // {
    //   columnName: 'Date of birth',
    //   columnProperty: "dob1"
    // },
    {
      columnName: this.translateService.instant(
        "customers.column_headers.last_booking",
      ),
      columnProperty: "l_booking_date",
    },
    // {
    //   columnName: this.translateService.instant('customers.column_headers.last_booking'),
    //   columnProperty: "last_booking_date"
    // },
    {
      columnName: this.translateService.instant(
        "customers.column_headers.payment_due",
      ),
      columnProperty: "total_due",
    },
  ];

  constructor(
    private _navService: NavigationService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    private _modelRef: MatDialog,
    private sharedService: SharedService,
    private messagingService: MessagingService,
    private angularFireMessaging: AngularFireMessaging,
    private loaderservice: LoaderServiceService,
    private translateService: TranslateService,
    private router: Router,
    private dialogService: DialogService,
    private authService: AuthService,
  ) {
    this._navService.hideSidebarAndNav = false;
    // this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
    //   this.ngOnInit();
    // })

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_CUSTOMERS_BY_ENTITY_ID
      ) {
        this.customersData = [];
        console.log(resData);
        if (resData.result && resData.result != null) {
          this.datalength = resData.result ? resData.result[0].total_count : 0;
          resData.result.forEach((element: any) => {
            if (element.gender == 1) {
              element.gender1 = "Male";
            } else if (element.gender == 2) {
              element.gender1 = "Female";
            } else if (element.gender == 3) {
              element.gender1 = "Others";
            } else if (!element.gender || element.gender == "null") {
              element.gender1 = "---";
            }

            if (element.dob && element.dob != "null") {
              element.dob1 = new Date(element.dob).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              });
            } else {
              element.dob1 = "---";
            }

            element.l_booking_date = "---";
            if (element.last_booking_date) {
              element.l_booking_date = this.formatDateToReadable(
                element.last_booking_date,
              );
            }

            if (!element.total_due) {
              element.total_due = 0;
            }
            element.cust_phone =
              (element.country_code ? element.country_code + " " : "") +
              element.phone;
            Object.keys(element).forEach((key) => {
              if ((element as any)[key] === null) {
                // delete (data as any)[key];
                if (
                  key != "image_thumb_url" &&
                  key != "country_code" &&
                  key != "email"
                ) {
                  (element as any)[key] = "---";
                }
              }
            });
            this.customersData.push(element);
          });
          console.log(this.customersData);
        }
        this._apiService.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
          ),
        );
      } else if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_CUSTOMERS_WITH_DUES_BY_ENTITY_ID
      ) {
        this.customersData = [];
        console.log(resData);
        if (resData.result && resData.result != null) {
          resData.result.forEach((element: any) => {
            if (element.gender == 1) {
              element.gender1 = "Male";
            } else if (element.gender == 2) {
              element.gender1 = "Female";
            } else if (element.gender == 3) {
              element.gender1 = "Others";
            } else if (!element.gender || element.gender == "null") {
              element.gender1 = "---";
            }

            if (element.dob && element.dob != "null") {
              element.dob1 = new Date(element.dob).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              });
            } else {
              element.dob1 = "---";
            }
            element.l_booking_date = "---";
            if (element.last_booking_date) {
              element.l_booking_date = this.formatDateToReadable(
                element.last_booking_date,
              );
            }

            if (!element.total_due) {
              element.total_due = 0;
            }
            element.cust_phone =
              (element.country_code ? element.country_code + " " : "") +
              element.phone;
            Object.keys(element).forEach((key) => {
              if ((element as any)[key] === null) {
                // delete (data as any)[key];
                if (
                  key != "image_thumb_url" &&
                  key != "country_code" &&
                  key != "email"
                ) {
                  (element as any)[key] = "---";
                }
              }
            });
            this.customersData.push(element);
          });
        }
        this.loaderservice.showLoader = false;
        this.loader = false;
      } else if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_LONG_ABSENT_CUSTOMERS_BY_ENTITY_ID
      ) {
        this.customersData = [];
        console.log(resData);
        if (resData.result && resData.result != null) {
          resData.result.forEach((element: any) => {
            if (element.gender == 1) {
              element.gender1 = "Male";
            } else if (element.gender == 2) {
              element.gender1 = "Female";
            } else if (element.gender == 3) {
              element.gender1 = "Others";
            } else if (!element.gender || element.gender == "null") {
              element.gender1 = "---";
            }

            if (element.dob && element.dob != "null") {
              element.dob1 = new Date(element.dob).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              });
            } else {
              element.dob1 = "---";
            }

            element.l_booking_date = "---";
            if (element.last_booking_date) {
              element.l_booking_date = this.formatDateToReadable(
                element.last_booking_date,
              );
            }

            if (!element.total_due) {
              element.total_due = 0;
            }

            element.cust_phone =
              (element.country_code ? element.country_code + " " : "") +
              element.phone;
            Object.keys(element).forEach((key) => {
              if ((element as any)[key] === null) {
                // delete (data as any)[key];
                if (
                  key != "image_thumb_url" &&
                  key != "country_code" &&
                  key != "email"
                ) {
                  (element as any)[key] = "---";
                }
              }
            });
            this.customersData.push(element);
          });
        }
        this.loaderservice.showLoader = false;
        this.loader = false;
      } else if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_CUSTOMER_BY_SEARCH
      ) {
        this.customersData = [];
        console.log(resData);
        if (resData.result && resData.result != null) {
          resData.result.forEach((element: any) => {
            if (element.gender == 1) {
              element.gender1 = "Male";
            } else if (element.gender == 2) {
              element.gender1 = "Female";
            } else if (element.gender == 3) {
              element.gender1 = "Others";
            } else if (!element.gender || element.gender == "null") {
              element.gender1 = "---";
            }

            if (element.dob && element.dob != "null") {
              element.dob1 = new Date(element.dob).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              });
            } else {
              element.dob1 = "---";
            }

            element.l_booking_date = "---";
            if (element.last_booking_date) {
              element.l_booking_date = this.formatDateToReadable(
                element.last_booking_date,
              );
            }

            if (!element.total_due) {
              element.total_due = 0;
            }

            element.cust_phone =
              (element.country_code ? element.country_code + " " : "") +
              element.phone;
            Object.keys(element).forEach((key) => {
              if ((element as any)[key] === null) {
                // delete (data as any)[key];
                if (key != "image_thumb_url") {
                  (element as any)[key] = "---";
                }
              }
            });
            this.customersData.push(element);
          });
        }
        this.loaderservice.showLoader = false;
        this.loader = false;
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_DISCOUNT
      ) {
        this.discountInfo = null;
        if (resData.result) {
          this.discountInfo = resData.result;
        }
        this.loaderservice.showLoader = false;
        this.loader = false;
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_CUSTOMER_DATA
      ) {
        if (resData.result) {
          this._apiService.getCustomersByEntityId(
            this.entityHashId,
            this.page.toString(),
          );
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE
      ) {
        if (resData.result) {
          if (this.selectedValue == "0") {
            this._apiService.getCustomersByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          } else if (this.selectedValue == "1") {
            this._apiService.getCustomersWithDuesByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          } else if (this.selectedValue == "2") {
            this._apiService.getLongAbsentCustomersByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          }
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS
      ) {
        if (resData.result) {
          if (this.selectedValue == "0") {
            this._apiService.getCustomersByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          } else if (this.selectedValue == "1") {
            this._apiService.getCustomersWithDuesByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          } else if (this.selectedValue == "2") {
            this._apiService.getLongAbsentCustomersByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          }
        }
      }

      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PAYMENT_RECORD
      ) {
        if (resData.result) {
          if (this.selectedValue == "0") {
            this._apiService.getCustomersByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          } else if (this.selectedValue == "1") {
            this._apiService.getCustomersWithDuesByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          } else if (this.selectedValue == "2") {
            this._apiService.getLongAbsentCustomersByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          }
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        if (resData.result) {
          if (this.selectedValue == "0") {
            this._apiService.getCustomersByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          } else if (this.selectedValue == "1") {
            this._apiService.getCustomersWithDuesByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          } else if (this.selectedValue == "2") {
            this._apiService.getLongAbsentCustomersByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          }
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_RECORD_FITNESS_INVOICE
      ) {
        if (resData.result) {
          if (this.selectedValue == "0") {
            this._apiService.getCustomersByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          } else if (this.selectedValue == "1") {
            this._apiService.getCustomersWithDuesByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          } else if (this.selectedValue == "2") {
            this._apiService.getLongAbsentCustomersByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          }
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        if (resData.result) {
          if (this.selectedValue == "0") {
            this._apiService.getCustomersByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          } else if (this.selectedValue == "1") {
            this._apiService.getCustomersWithDuesByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          } else if (this.selectedValue == "2") {
            this._apiService.getLongAbsentCustomersByEntityId(
              this.entityHashId,
              this.page.toString(),
            );
          }
        }
      }
      //   else if(resData.responseType === SM_CONSTANTS.ADD_UPDATE_SERVICE_TYPE_RESULT){
      //     if(resData.result && resData.result != null){
      //       this._apiService.getServices(this.entityHashId, this.selectedValue, this.page.toString())
      //     }
      //   }
      // this.loader = false;
      // this.loaderservice.showLoader = false
    });
    console.log(this.customersData);
    if (
      !localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == "null"
    ) {
      this.messagingService.requestPermission();
    }
    this.translateService.onLangChange.subscribe(() => {
      // Update your column headers when the language changes
      this.updateColumnHeaders();
    });
  }
  private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column, index) => {
      let data = ["name", "phone", "gender", "last_booking", "payment_due"];

      // Update each column header with the translated value
      column.columnName = this.translateService.instant(
        `customers.column_headers.${data[index]}`,
      );
    });
  }
  // private modelSubscription: Subscription = new Subscription();
  ngOnInit(): void {
    this.isOwner = this.authService.isOwner();
    this.isEntityIndividual = sessionStorage.getItem("isEntityIndividual");
    if (this.isOwner) {
      this.isAccessForEmployeeInvoice = true;
    } else {
      const ssa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_INVOICE_ACCESS,
      );
      const hsa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_INVOICE_ACCESS,
      );
      const vsa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_INVOICE_ACCESS,
      );

      const bsss = sessionStorage.getItem("shop_service_status");
      const bhss = sessionStorage.getItem("home_service_status");
      const bvss = sessionStorage.getItem("virtual_service_status");

      // sessionStorage.getItem() returns a string or null.

      // 2. Check if ANY of the retrieved values is the string '1'
      if (
        (ssa == "1" && bsss != "2") ||
        (hsa == "1" && bhss != "2") ||
        (vsa == "1" && bvss != "2")
      ) {
        this.isAccessForEmployeeInvoice = true;
      }
    }
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash;
    });

    this._apiService.getCustomersByEntityId(
      this.entityHashId,
      this.page.toString(),
    );
    // this.modelSubscription = this._modelRef.afterAllClosed.subscribe((data) => {
    //   this.loader = true;
    //   this._apiService.getServices(this.entityHashId)
    // });
  }
  selectedValue: string = "0";
  changeChip(value: string) {
    this.selectedValue = value;
    this.loader = true;
    this.loaderservice.showLoader = true;
    if (value == "0") {
      this._apiService.getCustomersByEntityId(
        this.entityHashId,
        this.page.toString(),
      );
    } else if (value == "1") {
      this._apiService.getCustomersWithDuesByEntityId(
        this.entityHashId,
        this.page.toString(),
      );
    } else if (value == "2") {
      this._apiService.getLongAbsentCustomersByEntityId(
        this.entityHashId,
        this.page.toString(),
      );
    }
  }
  createNotification(title: any, text: any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  onCreateNewService() {
    this._modelRef.open(AddServiceComponent, {
      width: "700px",
      data: {
        title: "Add service",
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
      },
    });
  }
  onCreateNewServiceFromTemplate() {
    this._modelRef.open(AddServiceTemplateItemComponent, {
      width: "1000px",
      data: {
        title: "Add service From Template",
        ref: this._modelRef,
      },
    });
  }

  viewdetailsopen(item: any) {
    this.router.navigate(["customers-details"], {
      queryParams: {
        entityHash: this.entityHashId,
        countryCode: item.country_code,
        phone: item.phone,
        name: item.name,
      },
      relativeTo: this.route,
    });
    // this.dialogService.openFullScreenDialog(CustomersViewDetailsComponent,data);
  }

  deactivateService(rowvalue: any) {
    console.log(rowvalue);
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        status: 7,
      },
    };

    this._apiService.addUpdateServiceType(metadata, this.entityHashId);

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  activateService(rowvalue: any) {
    console.log(rowvalue);
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        status: 1,
      },
    };

    this._apiService.addUpdateServiceType(metadata, this.entityHashId);

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  deleteService(rowvalue: any) {
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        isDelete: 1,
      },
    };

    this._apiService.addUpdateServiceType(metadata, this.entityHashId);

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  onEdit(rowvalue: any) {
    this._modelRef.open(AddServiceComponent, {
      width: "700px",
      data: {
        title: "Edit service",
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
        data: rowvalue,
      },
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    // this.clickEventSubscription.unsubscribe();
    // this.modelSubscription.unsubscribe();
  }

  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;

    this._apiService.getServices(
      this.entityHashId,
      this.selectedValue,
      this.page.toString(),
    );
  }

  firstTimeBelow3: boolean = false;

  searchServiceData() {
    if (this.searchString.value.length >= 3) {
      this.firstTimeBelow3 = true;
      this.page = 1;
      this._apiService.getCustomerDataByKeyword(
        this.entityHashId,
        this.page,
        this.searchString.value,
        this.selectedValue,
      );
    } else {
      if (this.firstTimeBelow3) {
        this.firstTimeBelow3 = false;
        this.page = 1;
        if (this.selectedValue == "0") {
          this._apiService.getCustomersByEntityId(
            this.entityHashId,
            this.page.toString(),
          );
        } else if (this.selectedValue == "1") {
          this._apiService.getCustomersWithDuesByEntityId(
            this.entityHashId,
            this.page.toString(),
          );
        } else if (this.selectedValue == "2") {
          this._apiService.getLongAbsentCustomersByEntityId(
            this.entityHashId,
            this.page.toString(),
          );
        }
      }
    }
  }

  reset() {
    this.firstTimeBelow3 = false;
    this.searchString.reset();
    this.page = 1;
    if (this.selectedValue == "0") {
      this._apiService.getCustomersByEntityId(
        this.entityHashId,
        this.page.toString(),
      );
    } else if (this.selectedValue == "1") {
      this._apiService.getCustomersWithDuesByEntityId(
        this.entityHashId,
        this.page.toString(),
      );
    } else if (this.selectedValue == "2") {
      this._apiService.getLongAbsentCustomersByEntityId(
        this.entityHashId,
        this.page.toString(),
      );
    }
  }
  openAllBookings(item: any) {
    console.log(item);
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(
      ["/businesses", "details", "customers", "all-bookings"],
      {
        queryParamsHandling: "merge",
        queryParams: { phone: item.phone, mn: item.name },
      },
    );
  }
  openAllPayments(item: any) {
    console.log(item);
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(
      ["/businesses", "details", "customers", "all-payments"],
      {
        queryParamsHandling: "merge",
        queryParams: {
          phone: item.phone,
          code: item.country_code,
          mn: item.name,
        },
      },
    );
  }
  openDueBookings(item: any) {
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(
      ["/businesses", "details", "customers", "due-bookings"],
      {
        queryParamsHandling: "merge",
        queryParams: { phone: item.phone, mn: item.name },
      },
    );
  }
  msg: any;

  openPaymentIntimation(item: any) {
    let data = {
      title: "Payment Intimation",
      ref: this._modelRef,
      data: item,
      type: 1,
      entity_hash: this.entityHashId,
    };
    this.dialogService.openFullScreenDialog(PaymentIntimationComponent,data);
  }

  createInvoice(customer: any) {
    let data = {
      title: "New Invoice",
      ref: this._modelRef,
      data: {
        entityHash: this.entityHashId,
        customer: customer,
        discountInfo: this.discountInfo,
      },
    };
    // this._modelRef.open(AddNewBookingComponent, {
    //   width: '700px',
    //   data: {
    //     title: 'New Booking',
    //     ref: this._modelRef,
    //     data: data
    //   },
    // });
    this.dialogService.openFullScreenDialog(
      CreateInvoiceForCustomersComponent,
      data,
    );
  }

  deleteCustomer(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this customer?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          customerHash: item.hash_id,
          entityHash: this.entityHashId,
        };

        this.loaderservice.showLoader = true;
        this._apiService.deleteEntityCustomer(obj);
      }
    });
  }

  addmember() {
    let data = {
      entityHash: this.entityHashId,
      link: "",
      title: "Add customer",
    };
    let dialogref = this.dialogService.openFullScreenDialog(
      AddCustomerComponent,
      data,
    );
    dialogref.afterClosed().subscribe((res) => {
      if (res.resData) {
        if (res.resData[0].errorcode == 1) {
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's another customer with the same name and phone number exists. If you really want to create one, change the name or phone number.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else {
          this.loaderservice.showLoader = true;
          this._apiService.getCustomersByEntityId(
            this.entityHashId,
            this.page.toString(),
          );
        }
      }
    });
  }

  customerviewdetails() {
    this.dialog.open(MemberViewDetailsComponent, {
      width: "500px",
      disableClose: true,
      data: {
        link: "",
        title: "Add member",
      },
    });
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "",
        title: "Business profile",
      },
    });
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }

  // viewdetailsopen(){
  //   this.router.navigate(['customers-view-details'],{relativeTo:this.route,queryParamsHandling:'merge'});
  // }

  formatDateToReadable(date: Date): string {
    // Use Angular's formatDate utility for localization and formatting
    return formatDate(date, "MMM d, y", "en-US");
  }
}
